/* global requestAnimationFrame */
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['progress']

  static values = {
    duration: Number,
    startingPercentage: Number
  }

  connect () {
    this.animateWithCubic()
  }

  animateWithCubic () {
    const start = performance.now()
    const targetStart = this.startingPercentageValue
    const targetProgress = 95
    const duration = this.durationValue
    const delta = targetProgress - targetStart

    const animate = (now) => {
      const elapsed = now - start
      const t = Math.min(elapsed / duration, 1)
      const eased = easeInOutCubic(t)
      const currentProgress = targetStart + delta * eased
      const progressPercent = `${currentProgress.toFixed(2)}%`

      this.progressTarget.style.width = progressPercent

      if (t < 1) {
        requestAnimationFrame(animate)
      }
    }

    requestAnimationFrame(animate)
  }
}

function easeInOutCubic (t) {
  return t < 0.5
    ? 4 * t * t * t
    : 1 - Math.pow(-2 * t + 2, 3) / 2
}
